import { SpyneTrait } from 'spyne';
import { compose, head, reject, isNil, values, pick} from 'ramda';
import { PageView } from 'components/pages/page-view.js';
import { Page404View } from 'components/pages/page-404-view.js';

import PageTmplBase from 'components/_design-system/templates/page.tmpl.html';
import PageTmplHome from 'components/pages/templates/page-home.tmpl.html';
import PageTmplContainers from 'components/_design-system/templates/page-containers.tmpl.html';
import PageTmplContainerCardGrid from 'components/_design-system/templates/page-containers-card-grid.tmpl.html';
import PageTmplComponentCards from 'components/_design-system/templates/page-components-cards.tmpl.html';
import PageTmplButton from 'components/_design-system/templates/page-elements-buttons.tmpl.html';
import PageTmplLinks from 'components/_design-system/templates/page-elements-links.tmpl.html';
import PageTmplTypography from 'components/_design-system/templates/page-elements-typography.tmpl.html';
import PageTmplForms from 'components/_design-system/templates/page-elements-forms.tmpl.html';
import PageTmplFormInputs from 'components/_design-system/templates/page-elements-forms-inputs.tmpl.html';
import PageTmplFormTextArea from 'components/_design-system/templates/page-elements-forms-textarea.tmpl.html';
import PageTmplFormCheckboxes from 'components/_design-system/templates/page-elements-forms-checkboxes.tmpl.html';
import PageTmplFormRadio from 'components/_design-system/templates/page-elements-forms-radio.tmpl.html';
import PageTmplFormSelect from 'components/_design-system/templates/page-elements-forms-select.tmpl.html';
import PageTmplLists from 'components/_design-system/templates/page-elements-lists.tmpl.html';
import PageTmplTables from 'components/_design-system/templates/page-elements-tables.tmpl.html';
import PageTmplSectionsPricing from 'components/_design-system/templates/page-sections-pricing.tmpl.html';
import PageTmplUtilities from 'components/_design-system/templates/page-utilities.tmpl.html';
import PageTmplHero from 'components/_design-system/templates/page-component-hero.tmpl.html';

export class DesignSystemTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'designSystem$';
    super(context, traitPrefix);
  }




  static designSystem$GetPageTemplate(routeData={pageId:'default'}, isDeepLink=false){
    routeData = isDeepLink ? routeData.initData.routeData : routeData;

  const templateId =  compose(head, reject(isNil), values, pick(['optionId', 'topicId', 'pageId', 'components']))(routeData);

  console.log('template id is ',{templateId, routeData})

    let tmpl = PageTmplBase;
    const tmplHash = {
      default: PageTmplBase,
      home: PageTmplHome,
      pricing: PageTmplSectionsPricing,
      containers: PageTmplContainers,
      "card-grid": PageTmplContainerCardGrid,
      card: PageTmplComponentCards,
      buttons: PageTmplButton,
      links:PageTmplLinks,
      lists: PageTmplLists,
      typography: PageTmplTypography,
      forms: PageTmplForms,
      input: PageTmplFormInputs,
      textarea: PageTmplFormTextArea,
      checkbox: PageTmplFormCheckboxes,
      radio: PageTmplFormRadio,
      select: PageTmplFormSelect,
      tables: PageTmplTables,
      primary: PageTmplButton,
      utilities: PageTmplUtilities,
      hero: PageTmplHero
    }
    return tmplHash[templateId] || tmpl
  }


}
